var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, Stack, TextField, Tooltip, Typography, } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { getApiErrorMessage } from "../../utils/forms.functions";
import { createFormSecondarySlug, deleteFormSecondarySlug, patchFormSlugAsDefault, patchFormSlugText, } from "../../apis/forms";
import { createNpsSecondarySlug, deleteNpsSecondarySlug, patchNpsSlugAsDefault, patchNpsSlugText, } from "../../apis/nps";
import { slugifyTitle, sortSlugs } from "../../utils/helpers";
var FormSlugsManagerDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, row = _a.row, accessToken = _a.accessToken, kind = _a.kind, onPatchRow = _a.onPatchRow;
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), busy = _c[0], setBusy = _c[1];
    var _d = useState(false), creating = _d[0], setCreating = _d[1];
    var _e = useState(""), newSlug = _e[0], setNewSlug = _e[1];
    var _f = useState(null), editingId = _f[0], setEditingId = _f[1];
    var _g = useState(""), editValue = _g[0], setEditValue = _g[1];
    useEffect(function () {
        if (!open) {
            setNewSlug("");
            setEditingId(null);
            setEditValue("");
            setError(null);
        }
    }, [open]);
    var handleDialogClose = function () {
        if (!busy && !creating)
            onClose();
    };
    var applySlugsPatch = function (nextSlugs) {
        if (!row)
            return;
        onPatchRow(row.id, { slugs: nextSlugs });
    };
    var handleCreate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmed, res, _a, created, merged, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!row || !accessToken)
                        return [2 /*return*/];
                    trimmed = newSlug.trim();
                    if (!trimmed)
                        return [2 /*return*/];
                    setCreating(true);
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    if (!(kind === "forms")) return [3 /*break*/, 3];
                    return [4 /*yield*/, createFormSecondarySlug(row.id, { slug: trimmed }, accessToken)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createNpsSecondarySlug(row.id, { slug: trimmed }, accessToken)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    res = _a;
                    created = res.data;
                    merged = __spreadArray(__spreadArray([], row.slugs, true), [created], false).sort(sortSlugs);
                    applySlugsPatch(merged);
                    setNewSlug("");
                    return [3 /*break*/, 8];
                case 6:
                    err_1 = _b.sent();
                    setError(getApiErrorMessage(err_1, "Não foi possível criar o slug."));
                    return [3 /*break*/, 8];
                case 7:
                    setCreating(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleSaveEdit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmed, res, _a, updated_1, merged, err_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!row || !accessToken || !editingId)
                        return [2 /*return*/];
                    trimmed = editValue.trim();
                    if (!trimmed)
                        return [2 /*return*/];
                    setBusy(true);
                    setError(null);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    if (!(kind === "forms")) return [3 /*break*/, 3];
                    return [4 /*yield*/, patchFormSlugText(row.id, editingId, { slug: trimmed }, accessToken)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, patchNpsSlugText(row.id, editingId, { slug: trimmed }, accessToken)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    res = _a;
                    updated_1 = res.data;
                    merged = row.slugs
                        .map(function (slug) { return (slug.id === updated_1.id ? __assign({}, updated_1) : __assign({}, slug)); })
                        .sort(sortSlugs);
                    applySlugsPatch(merged);
                    setEditingId(null);
                    setEditValue("");
                    return [3 /*break*/, 8];
                case 6:
                    err_2 = _b.sent();
                    setError(getApiErrorMessage(err_2, "Não foi possível atualizar o slug."));
                    return [3 /*break*/, 8];
                case 7:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleSetDefault = function (slugRow) { return __awaiter(void 0, void 0, void 0, function () {
        var merged, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!row || !accessToken || slugRow.isDefault)
                        return [2 /*return*/];
                    setBusy(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    if (!(kind === "forms")) return [3 /*break*/, 3];
                    return [4 /*yield*/, patchFormSlugAsDefault(row.id, slugRow.id, accessToken)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, patchNpsSlugAsDefault(row.id, slugRow.id, accessToken)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    merged = row.slugs.map(function (slug) { return (__assign(__assign({}, slug), { isDefault: slug.id === slugRow.id })); });
                    applySlugsPatch(merged);
                    return [3 /*break*/, 8];
                case 6:
                    err_3 = _a.sent();
                    setError(getApiErrorMessage(err_3, "Não foi possível definir o slug principal."));
                    return [3 /*break*/, 8];
                case 7:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (slugRow) { return __awaiter(void 0, void 0, void 0, function () {
        var merged, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!row || !accessToken || slugRow.isDefault)
                        return [2 /*return*/];
                    setBusy(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    if (!(kind === "forms")) return [3 /*break*/, 3];
                    return [4 /*yield*/, deleteFormSecondarySlug(row.id, slugRow.id, accessToken)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, deleteNpsSecondarySlug(row.id, slugRow.id, accessToken)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    merged = row.slugs.filter(function (slug) { return slug.id !== slugRow.id; });
                    applySlugsPatch(merged.sort(sortSlugs));
                    return [3 /*break*/, 8];
                case 6:
                    err_4 = _a.sent();
                    setError(getApiErrorMessage(err_4, "Não foi possível excluir o slug."));
                    return [3 /*break*/, 8];
                case 7:
                    setBusy(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var titleId = "form-slugs-manager-dialog-title";
    return (_jsxs(Dialog, __assign({ open: open, onClose: handleDialogClose, "aria-labelledby": titleId, fullWidth: true, maxWidth: "sm" }, { children: [_jsx(DialogTitle, __assign({ id: titleId, sx: { px: "24px", py: "10px" } }, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 1, alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Typography, __assign({ variant: "h6" }, { children: "Gerenciar slugs" })), _jsx(IconButton, __assign({ size: "medium", onClick: handleDialogClose }, { children: _jsx(CloseIcon, { fontSize: "medium" }) }))] })) })), _jsxs(DialogContent, { children: [(row === null || row === void 0 ? void 0 : row.title) !== undefined ? (_jsxs(Alert, __assign({ severity: "info", sx: { mb: 2 } }, { children: ["Formul\u00E1rio selecionado: ", _jsx("strong", { children: row.title })] }))) : null, _jsx(Typography, __assign({ variant: "body2", color: "text.secondary", sx: { mb: 1 } }, { children: "Principal \u00E9 o utilizado nos links p\u00FAblicos por padr\u00E3o. Slug principal n\u00E3o pode ser removido; altere s\u00F3 o texto ou defina outro como principal." })), _jsx(Typography, __assign({ variant: "subtitle2", sx: { mb: 1 } }, { children: "Adicionar slug secund\u00E1rio" })), _jsxs(Stack, __assign({ direction: "row", spacing: 1, sx: { mb: 2 } }, { children: [_jsx(TextField, { size: "small", label: "Slug", value: newSlug, disabled: busy || creating, onChange: function (e) { return setNewSlug(slugifyTitle(e.target.value)); }, placeholder: "alias-do-formulario", fullWidth: true }), _jsx(Button, __assign({ variant: "contained", disabled: busy || creating || !newSlug.trim(), onClick: handleCreate, sx: { flexShrink: 0 } }, { children: creating ? (_jsx(CircularProgress, { size: 22, color: "inherit" })) : ("Adicionar") }))] })), error && (_jsx(Alert, __assign({ severity: "error", sx: { mb: 2 } }, { children: error }))), _jsx(Typography, __assign({ variant: "subtitle2", sx: { mb: 1 } }, { children: "Slugs vinculados" })), _jsx(List, __assign({ dense: true, disablePadding: true, sx: { maxHeight: "300px", overflowY: "auto" } }, { children: row === null || row === void 0 ? void 0 : row.slugs.map(function (slugRow) {
                            var editing = editingId === slugRow.id;
                            return (_jsx(ListItem, __assign({ sx: {
                                    flexDirection: "column",
                                    alignItems: "stretch",
                                    borderBottom: "1px solid",
                                    borderColor: "divider",
                                    p: 1.25,
                                    gap: 1,
                                } }, { children: editing ? (_jsxs(Stack, __assign({ direction: "row", spacing: 1 }, { children: [_jsx(TextField, { size: "small", value: editValue, disabled: busy, onChange: function (e) {
                                                return setEditValue(slugifyTitle(e.target.value));
                                            }, fullWidth: true, label: "Slug" }), _jsx(Tooltip, __assign({ title: "Salvar" }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ size: "small", color: "primary", "aria-label": "salvar slug", disabled: busy || !editValue.trim(), onClick: handleSaveEdit }, { children: _jsx(CheckIcon, { fontSize: "small" }) })) }) })), _jsx(Tooltip, __assign({ title: "Cancelar" }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ size: "small", "aria-label": "cancelar edi\u00E7\u00E3o", disabled: busy, onClick: function () {
                                                        setEditingId(null);
                                                        setEditValue("");
                                                    } }, { children: _jsx(CloseIcon, { fontSize: "small" }) })) }) }))] }))) : (_jsxs(Stack, __assign({ direction: "row", alignItems: "center", spacing: 1, flexWrap: "wrap" }, { children: [_jsx(Typography, __assign({ component: "span", variant: "body2", sx: {
                                                fontFamily: "ui-monospace, monospace",
                                                flex: 1,
                                                minWidth: 120,
                                            } }, { children: slugRow.slug })), slugRow.isDefault && (_jsx(Typography, __assign({ component: "span", variant: "caption", color: "success.main", fontWeight: 600 }, { children: "Principal" }))), _jsx(Box, { sx: { flexGrow: 1 } }), _jsx(Tooltip, __assign({ title: "Editar texto" }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ size: "small", "aria-label": "editar slug", disabled: busy, onClick: function () {
                                                        setEditingId(slugRow.id);
                                                        setEditValue(slugRow.slug);
                                                    } }, { children: _jsx(EditOutlinedIcon, { fontSize: "small" }) })) }) })), _jsx(Tooltip, __assign({ title: "Definir como principal" }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ size: "small", "aria-label": "definir como principal", disabled: busy || slugRow.isDefault, onClick: function () { return handleSetDefault(slugRow); } }, { children: _jsx(StarOutlineIcon, { fontSize: "small" }) })) }) })), _jsx(Tooltip, __assign({ title: "Excluir slug secund\u00E1rio" }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ size: "small", "aria-label": "excluir slug", color: "error", disabled: busy || slugRow.isDefault, onClick: function () { return handleDelete(slugRow); } }, { children: _jsx(DeleteOutlineIcon, { fontSize: "small" }) })) }) }))] }))) }), slugRow.id));
                        }) })), (row === null || row === void 0 ? void 0 : row.slugs.length) === 0 && (_jsx(Typography, __assign({ variant: "body2", color: "text.secondary", sx: { py: 1 } }, { children: "Nenhum slug listado. Adicione um slug secund\u00E1rio ou recarregue a listagem." })))] })] })));
};
export default FormSlugsManagerDialog;
